import request from '@/utils/request'

export function uploadImage(data) {
  return request({
    url: '/v1/images',
    method: 'post',
    data
  })
}

export function fetchMaskImages(id) {
  return request({
    url: '/v1/images/' + id + '/masks',
    method: 'get'
  })
}